import React from 'react';
import { marked } from 'marked';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const MarkdownToHtml = ({ content, className, removeDefaultStyle }) => {
  if (!content || !content.length) return <></>;
  const renderer = new marked.Renderer();

  renderer.link = (href, title, text) => {
    const titleAttr = title ? ` title="${title}"` : '';
    const isExternal = /^https?:\/\//i.test(href); // This checks whether href starts with http:// or https://.

    // Open external links in the new tab
    const attrs = isExternal ? ' target="_blank" rel="noopener noreferrer"' : '';

    return `<a href="${href}"${titleAttr}${attrs}>${text}</a>`;
  };

  marked.setOptions({
    gfm: true,
    tables: true,
    breaks: false,
    pedantic: false,
    sanitize: false,
    smartLists: true,
    smartypants: false,
    renderer,
  });
  return (
    <>
      <article
        className={clsx('font-body', { prose: !removeDefaultStyle }, className)}
        dangerouslySetInnerHTML={{ __html: marked.parse(content) }}
      />
    </>
  );
};

MarkdownToHtml.propTypes = {
  content: PropTypes.string.isRequired,
  className: PropTypes.string,
  removeDefaultStyle: PropTypes.bool,
};

MarkdownToHtml.defaultProps = {
  className: undefined,
  removeDefaultStyle: false,
};

export default MarkdownToHtml;
